module.exports = __webpack_public_path__ + "static/sport/form-box.5560ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/form-box.png
// module id = CSlH
// module chunks = 0